module.exports = __webpack_public_path__ + "static/00b2d3ede38662bb1b736f12823ad8fdcdaa18672831b35b8d13a6383c6d2aad-88bdeec26f2575979ee019703a1d06f8.png";